module.exports = __webpack_public_path__ + "static/media/gallery-14.10437fb5.jpg";